// @flow

import * as React from 'react'
import { Label, Segment, Header, Message } from 'semantic-ui-react'
import { DataGrid, DataGridDuck } from 'react-redux-components'
import { connect, type Connector } from 'react-redux'

import authenticatedRequest from '../store/authenticated-request'
import CampaignsDropdown from '../systemwide/allowed-campaigns-dropdown'
import VisitsToolbar from './visits-toolbar'
import VisitsForm from './visits-form'
import Modal from '../systemwide/modal'
import { cancelEdit, updateVisit, deleteVisitCancel, deleteVisit, type Visit } from '../store/manage-visits'
import { isViewer } from '../store/authentication'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentRecord: Visit | false,
  currentCampaign: string,
  campaignFromRoute: boolean,
  formPristine: boolean,
  deleteVisitPending: Visit | false,
  isViewer: boolean,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let hasSelection = state.visits.grid.selectedRecords.length > 0
  return {
    currentRecord: hasSelection ? state.visits.grid.selectedRecords[0] : false,
    currentCampaign: state.allowedCampaigns.currentCampaign,
    campaignFromRoute: 'campaignName' in state.location.payload,
    formPristine: state.visits.form.$form.pristine,
    deleteVisitPending: state.visits.ui.deleteVisitPending,
    isViewer: isViewer(state),
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

class VisitsPage extends React.Component<Props> {
  static defaultProps = {}

  columns = [
    { key: 'id_medico', name: 'ID medico', resizable: true, sortable: true, width: 100 },
    { key: 'nome', name: 'Nome medico', resizable: false, sortable: true },
    { key: 'cognome', name: 'Cognome medico', resizable: false, sortable: true },
    { key: 'data_visita', name: 'Data visita', resizable: false, sortable: true, width: 100 },
    { key: 'prodotto', name: 'Prodotto', resizable: true, sortable: true },
    { key: 'canale', name: 'Canale', resizable: false, sortable: true, width: 90 },
    { key: 'isf', name: 'ISF', resizable: true, sortable: true },
    { key: 'call_experience', name: 'Call experience', resizable: false, sortable: true, width: 125 },
    { key: 'uploaded_by', name: 'Caricato da', resizable: true, sortable: true },
    { key: 'wave', name: 'Wave', resizable: true, sortable: true },
  ]

  cancelEdit = () => {
    this.props.dispatch(cancelEdit())
  }

  commitEdit = (visit: Visit) => {
    this.props.dispatch(updateVisit(this.props.currentCampaign, visit))
  }

  deleteVisitCancel = () => {
    this.props.dispatch(deleteVisitCancel())
  }

  deleteVisit = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(deleteVisit(this.props.currentCampaign, this.props.currentRecord))
    }
  }

  render() {
    let dataVisita = typeof this.props.deleteVisitPending !== 'boolean' ? this.props.deleteVisitPending.data_visita : ''
    let idMedico = typeof this.props.deleteVisitPending !== 'boolean' ? this.props.deleteVisitPending.id_medico : ''
    let verb = this.props.isViewer ? 'Visualizzazione' : 'Gestione'

    return (
      <div style={{ height: '100vh', paddingTop: '9ex' }}>
        <Modal
          open={typeof this.props.deleteVisitPending !== 'boolean'}
          header={<Header icon="delete" content="Conferma eliminazione visita" />}
          content={
            <span>
              {'Eliminare la visita effettuata in data ' + dataVisita + ' al medico con ID ' + idMedico + '?'}
              <br />Questa operazione è irreversibile
            </span>
          }
          onCancel={this.deleteVisitCancel}
          onConfirm={this.deleteVisit}
        />
        {this.props.currentCampaign === '' && (
          <Message
            style={{
              marginTop: '40vh',
              marginLeft: '33vw',
              position: 'absolute',
              zIndex: '1000',
              width: '33vw',
              textAlign: 'center',
            }}
            floating
            info>
            <Message.Header>Gestisci Visite</Message.Header>
            <p>Selezionare una campagna dal menù a tendina in alto a destra</p>
          </Message>
        )}
        <Segment
          padded={false}
          secondary
          style={{ margin: '0 3ex 0 3ex', height: '90vh', display: 'flex', flexDirection: 'column' }}>
          <Label attached="top" color="blue" size="small" style={{ zIndex: '700', width: '100%' }}>
            <div style={{ fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>{`${verb} Visite`}</div>
            {this.props.campaignFromRoute && (
              <div style={{ float: 'right', height: '2rem' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  {this.props.currentCampaign}
                </span>
              </div>
            )}
            {!this.props.campaignFromRoute && (
              <div style={{ float: 'right' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  Seleziona campagna:
                </span>
                <CampaignsDropdown
                  onChangeAction={DataGridDuck.creators.resetDatagrid('visitsGrid')}
                  style={{ minWidth: '40ex' }}
                />
              </div>
            )}
          </Label>
          <DataGrid
            disabled={true}
            model="visitsGrid"
            fetchOnMount={false}
            request={authenticatedRequest}
            columns={this.columns}
            dataUrl={this.props.currentCampaign !== '' ? '/api/visits/' + this.props.currentCampaign + '/list' : ''}
            initialPageSize={40}
            toolbarContent={<VisitsToolbar />}
            sidebarContent={
              this.props.currentRecord && (
                <VisitsForm
                  loadedRecord={Object.keys(this.props.currentRecord)}
                  pristine={this.props.formPristine}
                  onCancel={this.cancelEdit}
                  onSubmit={this.commitEdit}
                />
              )
            }
          />
        </Segment>
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(VisitsPage)



// WEBPACK FOOTER //
// ./src/visits/manage-visits.js